import { StyledEngineProvider, ThemeProvider } from '@mui/material'
import { AuthenticatedRoute } from 'components/AuthenticatedRoute'
import ConnectedSnackbar from 'components/ConnectedSnackbar'
import { useEffect } from 'react'
import { Route, Routes } from 'react-router'
import { theme } from 'theme/theme-md'
import styles from './AdminApp.pcss'
import AdminRoot from './components/AdminRoot'
import Login from './routes/login'

const AdminApp = () => {
  useEffect(() => {
    const linkElement = document.createElement('link')
    linkElement.id = 'link-favicon'
    linkElement.rel = 'shortcut icon'
    linkElement.type = 'image/png'
    linkElement.href = '/static/img/favicon-admin.png'
    document.head.appendChild(linkElement)

    return () => {
      document.getElementById('link-favicon')?.remove()
    }
  }, [])

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <div className={styles['admin-panel']}>
          <Routes>
            <Route path="login" element={<Login />} />
            <Route
              path="/*"
              element={(
                <AuthenticatedRoute admin>
                  <AdminRoot />
                </AuthenticatedRoute>
              )}
              errorElement={<Login />}
            />
          </Routes>
          <ConnectedSnackbar />
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default AdminApp
